import { Header } from '@/components/Header';
import { ProductCard } from '@/components/ProductCard';
import { ProductCardSkeleton } from '@/components/ProductCardSkeleton';
import { AppFooter } from '@/components/AppFooter';
import { useProducts } from '@/hooks/use-products';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useSearchParams } from 'react-router-dom';
import { useState } from 'react';

const Index = () => {
  const [searchParams] = useSearchParams();
  const [searchQuery, setSearchQuery] = useState(searchParams.get('q') || '');



  const { products, isLoading, error, loadMore, hasMore } = useProducts({
    per_page: 20,
    sort_by: 'created_at',
    sort_order: 'desc',
    search: searchQuery, // Pass search query
  });

  const handleSearch = (query: string) => {
    console.log('Global search triggered:', query);
    setSearchQuery(query);
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header onSearch={handleSearch} />
      <main className="flex-1 container mx-auto px-4 py-8">
        <h2 className="text-2xl font-bold mb-6">
          {searchQuery ? `Search Results for "${searchQuery}"` : 'All Products'}
        </h2>

        {error && (
          <div className="bg-blue-50 border border-blue-200 text-blue-800 px-4 py-3 rounded-lg mb-6">
            <p className="font-semibold">Demo Mode</p>
            <p className="text-sm">
              Showing sample products. Live data will be available when the API is online.
            </p>
          </div>
        )}

        {isLoading && products.length === 0 ? (
          <div className="flex items-center justify-center py-12">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
            <span className="ml-2 text-muted-foreground">Loading products...</span>
          </div>
        ) : (
          <>
            {products.length === 0 && !isLoading ? (
              <div className="text-center py-12">
                <p className="text-muted-foreground">
                  No products found{searchQuery ? ` for "${searchQuery}"` : ''}.
                </p>
              </div>
            ) : (
              <>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 mb-8">
                  {isLoading
                    ? Array.from({ length: 20 }).map((_, index) => (
                        <ProductCardSkeleton key={`skeleton-${index}`} />
                      ))
                    : products.map((product) => (
                        <ProductCard key={product.id} product={product} />
                      ))}
                </div>

                {hasMore && (
                  <div className="flex justify-center">
                    <Button onClick={loadMore} disabled={isLoading} size="lg" variant="outline">
                      {isLoading ? (
                        <>
                          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                          Loading...
                        </>
                      ) : (
                        'Load More Products'
                      )}
                    </Button>
                  </div>
                )}
              </>
            )}
          </>
        )}
      </main>
      <AppFooter />
    </div>
  );
};

export default Index;
